import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { FiX } from 'react-icons/fi';
import { CSSTransition } from 'react-transition-group';

function SimpleModal(props) {
  const { show, onClose, children, contentClassName, hideCloseButton, closeOnOverlayClick = true } = props;

  function closeOnEscapeKeyDown(event) {
    if (event.key === 'Escape') onClose();
  }

  useEffect(() => {
    if (onClose) {
      document.body.addEventListener('keydown', closeOnEscapeKeyDown);
      return () => {
        document.body.removeEventListener('keydown', closeOnEscapeKeyDown);
        document.body.style.overflow = 'visible';
      };
    }
  }, []);

  useEffect(() => {
    if (show) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = 'visible';
  }, [show]);

  const nodeRef = React.useRef(null); //Fix react-transition-groupsimple-modal

  return ReactDOM.createPortal(
    <CSSTransition
      in={show}
      unmountOnExit
      nodeRef={nodeRef}
      timeout={{ enter: 0, exit: 300 }}
    >
      <div
        className={`simple-modal ${show ? 'active' : ''}`}
        onClick={closeOnOverlayClick ? onClose : undefined}
        ref={nodeRef}
      >
        <div
          className={`simple-modal__content ${contentClassName}`}
          onClick={event => event.stopPropagation()}
        >
          {!hideCloseButton && (
            <button
              className="card__icon-wrapper card__icon-wrapper--sm"
              onClick={onClose}
            >
              <FiX className="card__icon" />
            </button>
          )}

          {children}
        </div>
      </div>
    </CSSTransition>,
    document.getElementById('modal_root')
  );
}

export default SimpleModal;
